import { registerSharedDependency } from 'core-components/helpers/MFHelper'
import { Crud } from 'src/core/types/Crud'
import Logger from 'src/core/utils/Logger'

import { crudStoreEventBus, CrudStoreEvents } from './eventBus'
import { ICrudObjects } from './models/ICrudObjects'

export class CrudStoreClass {
  private crudObjects: ICrudObjects = {}

  private getCrudStoreIdByInstance = (crud: Crud) => {
    for (const id of Object.keys(this.crudObjects)) {
      for (const key of Object.keys(this.crudObjects[id])) {
        if (this.crudObjects[id][key] === crud) {
          return id
        }
      }
    }

    return ''
  }

  constructor() {
    crudStoreEventBus.subscribe(
      CrudStoreEvents.onCrudChanged,
      (
        _,
        action: 'delete' | 'update' | 'create',
        item: unknown,
        crud: Crud,
        notifyOtherInstances: boolean = true
      ) => {
        const crudId = this.getCrudStoreIdByInstance(crud)
        if (crudId) {
          for (const key of Object.keys(this.crudObjects[crudId])) {
            const instance = this.crudObjects[crudId][key]
            switch (action) {
              case 'delete':
                instance.deleteItem({ models: item })
                break
              case 'update':
              case 'create':
                instance.updateItem({
                  models: item,
                  keyField: instance.keyField,
                  notifyToGlobalBus: false,
                  notifyOtherInstances,
                  hierarchyField: instance.hierarchyField,
                })
                break
            }
          }
        }
      }
    )
  }

  public add = <T, R>(crud: Crud<T, R>, id: string) => {
    this.crudObjects[id] = { default: crud }
  }

  public get<T = any, R = any>(id: string, key?: string) {
    const crudObject = this.crudObjects[id]
    if (!crudObject) {
      Logger.error(`CrudStore::: Can't find crud with key ${id}`)
    }

    const currentCrud = crudObject && crudObject[key || 'default']
    if (!currentCrud && key) {
      this.crudObjects[id][key] = this.crudObjects[id]['default'].clone()
      const { fetcher } = this.crudObjects[id]['default']
      if (fetcher.clone) {
        // remove this after extends all fetchers from AbstractFetcher
        this.crudObjects[id][key].fetcher = fetcher.clone()
      } else {
        if (window) {
          Logger.error('Fetcher must extends from AbstractFetcher')
        }
      }
      return this.crudObjects[id][key]
    }
    return currentCrud as Crud<T, R>
  }

  public has(id: string, key?: string) {
    const crudObject = this.crudObjects[id]
    return crudObject && (crudObject[key || 'default'] || crudObject['default'])
  }
}
export const CrudStore = registerSharedDependency<CrudStoreClass>(
  'CrudStore',
  () => new CrudStoreClass()
)
